/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DriverFeedbackFlagSetReq,
    DriverFeedbackFlagSetReqFromJSON,
    DriverFeedbackFlagSetReqToJSON,
    DriverFeedbackFlagSetResp,
    DriverFeedbackFlagSetRespFromJSON,
    DriverFeedbackFlagSetRespToJSON,
    WeeklyDriverShiftsList,
    WeeklyDriverShiftsListFromJSON,
    WeeklyDriverShiftsListToJSON,
    WeeklyReportsList,
    WeeklyReportsListFromJSON,
    WeeklyReportsListToJSON,
    WeeklyReportsOfficeRequest,
    WeeklyReportsOfficeRequestFromJSON,
    WeeklyReportsOfficeRequestToJSON,
    WeeklyShiftsDriverRequest,
    WeeklyShiftsDriverRequestFromJSON,
    WeeklyShiftsDriverRequestToJSON,
} from '../models';

export interface GetWeeklyReportsByOfficeRequest {
    weeklyReportsOfficeRequest?: WeeklyReportsOfficeRequest;
}

export interface GetWeeklyShiftsByDriverRequest {
    weeklyShiftsDriverRequest?: WeeklyShiftsDriverRequest;
}

export interface SetWeeklyDriverFeedbackFlagRequest {
    driverFeedbackFlagSetReq?: DriverFeedbackFlagSetReq;
}

/**
 * 
 */
export class WeeklyReportsApi extends runtime.BaseAPI {

    /**
     * 週次リポート
     */
    async getWeeklyReportsByOfficeRaw(requestParameters: GetWeeklyReportsByOfficeRequest): Promise<runtime.ApiResponse<WeeklyReportsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/weekly_reports_by_office`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WeeklyReportsOfficeRequestToJSON(requestParameters.weeklyReportsOfficeRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WeeklyReportsListFromJSON(jsonValue));
    }

    /**
     * 週次リポート
     */
    async getWeeklyReportsByOffice(requestParameters: GetWeeklyReportsByOfficeRequest): Promise<WeeklyReportsList> {
        const response = await this.getWeeklyReportsByOfficeRaw(requestParameters);
        return await response.value();
    }

    /**
     * driver毎週次乗務
     */
    async getWeeklyShiftsByDriverRaw(requestParameters: GetWeeklyShiftsByDriverRequest): Promise<runtime.ApiResponse<WeeklyDriverShiftsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/weekly_shifts_by_driver`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WeeklyShiftsDriverRequestToJSON(requestParameters.weeklyShiftsDriverRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WeeklyDriverShiftsListFromJSON(jsonValue));
    }

    /**
     * driver毎週次乗務
     */
    async getWeeklyShiftsByDriver(requestParameters: GetWeeklyShiftsByDriverRequest): Promise<WeeklyDriverShiftsList> {
        const response = await this.getWeeklyShiftsByDriverRaw(requestParameters);
        return await response.value();
    }

    /**
     * 声かけフラグを設定
     */
    async setWeeklyDriverFeedbackFlagRaw(requestParameters: SetWeeklyDriverFeedbackFlagRequest): Promise<runtime.ApiResponse<DriverFeedbackFlagSetResp>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/weekly_driver_feedback_flag`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DriverFeedbackFlagSetReqToJSON(requestParameters.driverFeedbackFlagSetReq),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DriverFeedbackFlagSetRespFromJSON(jsonValue));
    }

    /**
     * 声かけフラグを設定
     */
    async setWeeklyDriverFeedbackFlag(requestParameters: SetWeeklyDriverFeedbackFlagRequest): Promise<DriverFeedbackFlagSetResp> {
        const response = await this.setWeeklyDriverFeedbackFlagRaw(requestParameters);
        return await response.value();
    }

}
